import { buildImportFormData, LONG_REQUEST_TIMEOUT_MS } from "./fileUploadHelpers";

/**
 * Import one skill into a course from `source`: a file (a `.json` or a ZIP, sent as it is) or a folder's files.
 * The group chosen on the page, when there is one, goes as the form field `skill_group_id`, whatever the source;
 * the file is never rewritten. Without one, the server puts the skill in the course's group its file names.
 */
export const importSkill = (apiClient, courseId, source, groupId) => apiClient.post(
  `/backoffice/v1/courses/${encodeURIComponent(courseId)}/skills/import/`,
  buildImportFormData(source, groupId && groupId !== "ungrouped" ? { skill_group_id: groupId } : {}),
  { timeout: LONG_REQUEST_TIMEOUT_MS },
);

/**
 * Import every skill group and skill of `source` into a course: a file (a `.json` or a ZIP, sent as it is) or a
 * folder's files. The server skips a group or a skill whose name the course has already.
 */
export const importAllSkills = (apiClient, courseId, source) => apiClient.post(
  `/backoffice/v1/courses/${encodeURIComponent(courseId)}/skills/import-all/`, buildImportFormData(source),
  { timeout: LONG_REQUEST_TIMEOUT_MS },
);
